import { render } from "./select-role.html?vue&type=template&id=446b6613&scoped=true&ts=true"
import script from "./select-role.ts?vue&type=script&lang=ts"
export * from "./select-role.ts?vue&type=script&lang=ts"

import "./select-role.scss?vue&type=style&index=0&id=446b6613&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-446b6613"]])

export default __exports__